import type { LoginRequest, PhoneVerifyRequest } from '@/core/generated/api';
import { cleanPhone } from '@/core/format';
import type { CredentialsFormValues, VerificationFormValues } from './model/schema';

/** Преобразует данные входа в запрос авторизации */
export const credentialsToLoginRequest = (values: CredentialsFormValues): LoginRequest => ({
    phone: cleanPhone(values.phone),
    password: values.password,
    role: values.role,
});

/** Преобразует код и идентификатор сообщения в запрос подтверждения */
export const verificationToRequest = (
    values: VerificationFormValues,
    messageUuid: string,
): PhoneVerifyRequest => ({
    deviceToken: 'manage-web',
    baseMessageItem: {
        messageUuid,
        code: Number(values.code),
    },
});
